export const REPLACE_ON_NAVIGATE = {
    createGuestLink: true,
    guestDetails: false,
    manageGuestLinks: false,
};
